import React, { useRef, useState, useCallback, useEffect } from 'react';
import actions from '@src/redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import PodiumItem from './PodiumItem';
import { StyledPodium } from '../index.style';

const Podium = ({
  topVoices = [],
  activeTab,
  isLoading,
  favouriteVoiceCodes,
  onFavoriteToggleRequest,
  onHandleFavoriteProcessingComplete,
  onErrorProcessingFavouriteVoices,
  setFavouriteVoiceCodes,
}) => {
  const dispatch = useDispatch();
  const audioRef = useRef(null);
  const [audioSrc, setAudioSrc] = useState('');
  const [playingVoice, setPlayingVoice] = useState(null);
  const { currentPlayingVoiceId } = useSelector(
    (state) => state.audioVoiceLibrary,
  );

  const handlePlayAudio = useCallback(
    (voice) => {
      if (!audioRef.current) return;

      if (
        audioSrc === voice?.demo &&
        !audioRef.current.paused &&
        playingVoice === voice?.code
      ) {
        audioRef.current.pause();
        setPlayingVoice(null);
        dispatch(actions.layout.setIsPlayingVoicePodium(false));
      } else {
        setAudioSrc(voice?.demo);
        setPlayingVoice(voice?.code);
        dispatch(actions.layout.setIsPlayingVoicePodium(true));
        setTimeout(() => {
          if (audioRef.current) {
            audioRef.current.load();
            audioRef.current.play();
          }
        }, 0);
      }
    },
    [audioSrc, playingVoice, audioRef?.current],
  );

  const handlePauseAudio = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.pause();
    }
    setPlayingVoice(null);
    dispatch(actions.layout.setIsPlayingVoicePodium(false));
  }, [audioRef?.current]);

  useEffect(() => {
    handlePauseAudio();
    setAudioSrc('');
    setPlayingVoice(null);
    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.pause();
    }
    dispatch(actions.layout.setIsPlayingVoicePodium(false));
  }, [activeTab]);

  useEffect(() => {
    if (currentPlayingVoiceId) {
      handlePauseAudio();
    }
  }, [currentPlayingVoiceId]);

  return (
    <StyledPodium>
      {isLoading
        ? [{ rank: 2 }, { rank: 1 }, { rank: 3 }].map((voice) => (
            <PodiumItem voice={voice} isLoading />
          ))
        : topVoices.map((voice) => (
            <PodiumItem
              key={voice?.code}
              voice={voice}
              isPlaying={playingVoice === voice?.code}
              onPlayAudio={() => handlePlayAudio(voice)}
              onPauseAudio={handlePauseAudio}
              favouriteVoiceCodes={favouriteVoiceCodes}
              onFavoriteToggleRequest={onFavoriteToggleRequest}
              onHandleFavoriteProcessingComplete={
                onHandleFavoriteProcessingComplete
              }
              onErrorProcessingFavouriteVoices={
                onErrorProcessingFavouriteVoices
              }
              setFavouriteVoiceCodes={setFavouriteVoiceCodes}
            />
          ))}
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <audio
        ref={audioRef}
        onEnded={handlePauseAudio}
        src={audioSrc}
        preload="auto"
      />
    </StyledPodium>
  );
};

export default Podium;
